import { ConditionIssueInstanceModel } from '../../api/api';

export const TIME_FORMAT = 'h:mm A';
export const DATE_FORMAT = 'MM/DD/YYYY';
export type MappedCIs = Record<string, ConditionIssueInstanceModel[]>;
